import React, { useState, useCallback } from 'react';
import { publishVideo } from './api';
import useCsrfToken from '../ArticleFormNew/hooks/useCsrfToken';
import useVideoStore from './stores/useVideoStore';
import { useTranslations } from '../ArticleFormNew/contexts/TranslationContext';
import VideoPreviewModal from './VideoPreviewModal';
import SharedPublishPanel from '../shared/PublishPanel';

export default function VideoPublishPanel({ saveNow, compact }) {
  var t = useTranslations();
  var csrfToken = useCsrfToken();
  var isPublishingState = useState(false);
  var isPublishing = isPublishingState[0];
  var setIsPublishing = isPublishingState[1];

  var id = useVideoStore(function(s) { return s.id; });
  var slug = useVideoStore(function(s) { return s.slug; });
  var autosaveToken = useVideoStore(function(s) { return s.autosave_token; });
  var published = useVideoStore(function(s) { return s.published; });
  var hasPublishRecord = useVideoStore(function(s) { return s.has_publish_record; });
  var saveStatus = useVideoStore(function(s) { return s.saveStatus; });
  var publishErrors = useVideoStore(function(s) { return s.publishErrors; });
  var setPublishErrors = useVideoStore(function(s) { return s.setPublishErrors; });

  var saving = saveStatus === 'saving' || isPublishing;

  var handleSaveDraft = useCallback(function() {
    if (saveNow) saveNow();
  }, [saveNow]);

  var handlePublish = useCallback(function() {
    if (!id || isPublishing) return;
    setPublishErrors({});
    setIsPublishing(true);

    publishVideo(csrfToken, id, autosaveToken)
      .then(function(result) {
        if (result.status === 422 && result.data.errors) {
          setPublishErrors(result.data.errors);
        } else if (result.data.success) {
          window.location.href = result.data.redirect_url || '/articles/videos';
        } else {
          setPublishErrors({ base: [result.data.error || 'Submit failed'] });
        }
      })
      .catch(function() {
        setPublishErrors({ base: ['An unexpected error occurred'] });
      })
      .finally(function() {
        setIsPublishing(false);
      });
  }, [id, autosaveToken, csrfToken, isPublishing, setPublishErrors]);

  return (
    <SharedPublishPanel
      id={id}
      slug={slug}
      published={published}
      hasPublishRecord={hasPublishRecord}
      saveStatus={saveStatus}
      publishErrors={publishErrors}
      setPublishErrors={setPublishErrors}
      onSaveDraft={handleSaveDraft}
      onPublish={handlePublish}
      saving={saving}
      isPublishing={isPublishing}
      deleteUrl={'/articles/videos/' + (slug || id)}
      deleteTitle={t.delete_video}
      deleteConfirm={t.delete_confirm}
      PreviewComponent={VideoPreviewModal}
      previewIdProp="videoId"
      translations={t}
      compact={compact}
    />
  );
}
